export default {
    loading: false,
}